import React, { FunctionComponent } from 'react';

import { ICampaignContent } from 'models/campaignContent';
import { Layout } from 'models/layouts';

import getCampaignContentComponent from './getCampaignContentComponent';

type CampaignContentProps = {
  layout?: Layout;
  campaignContent: ICampaignContent;
  colour: string;
};
const CampaignContent: FunctionComponent<CampaignContentProps> = ({
  layout,
  campaignContent,
  colour,
}) => {
  return (
    getCampaignContentComponent(layout, campaignContent, colour) || (
      <div>Component Not Found</div>
    )
  );
};

export default CampaignContent;
